var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-layer",class:[_vm.layerStyle, { 'is-layer': _vm.layer }, _vm.customClass]},[_c('div',{staticClass:"loading-wrap"},[_c('svg',{staticClass:"loading",attrs:{"viewBox":"25, 25, 50, 50"}},[_c('circle',{staticClass:"circle",attrs:{"cx":"50","cy":"50","r":"12","stroke":_vm.color}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }